import { useState } from "react";
import { motion } from "framer-motion";

interface TipSelectorProps {
  onTipSelect: (amount: number) => void;
  primaryColor: string;
  fmt: (v: number) => string;
  tipValues?: number[];
}

const DEFAULT_TIP_OPTIONS = [2, 5, 10];

export const TipSelector = ({ onTipSelect, primaryColor, fmt, tipValues }: TipSelectorProps) => {
  const TIP_OPTIONS = tipValues && tipValues.length > 0 ? tipValues : DEFAULT_TIP_OPTIONS;
  const [selectedTip, setSelectedTip] = useState<number | null>(null);
  const [customTip, setCustomTip] = useState("");
  const [showCustom, setShowCustom] = useState(false);

  const handleSelect = (amount: number) => {
    setSelectedTip(amount);
    setShowCustom(false);
    onTipSelect(amount);
  };

  const handleCustom = () => {
    const val = Number(customTip);
    if (val > 0) {
      setSelectedTip(val);
      onTipSelect(val);
    }
  };

  return (
    <div className="rounded-2xl bg-white border border-[hsl(0,0%,92%)] p-4 shadow-sm">
      <p className="font-bold text-sm text-[hsl(0,0%,13%)]">Que tal agradecer com uma gorjeta?</p>
      <p className="text-xs text-[hsl(0,0%,55%)] mt-0.5">Repassamos 100% do valor pra quem faz a entrega • via PIX</p>

      <div className="flex gap-2 mt-4">
        {TIP_OPTIONS.map((amount) => (
          <button
            key={amount}
            onClick={() => handleSelect(amount)}
            className={`flex-1 py-3 rounded-xl border-2 text-sm font-bold transition-all active:scale-95 ${
              selectedTip === amount && !showCustom
                ? "text-white border-transparent"
                : "border-[hsl(0,0%,88%)] text-[hsl(0,0%,30%)]"
            }`}
            style={selectedTip === amount && !showCustom ? { backgroundColor: primaryColor } : {}}
          >
            {fmt(amount)}
          </button>
        ))}
        <button
          onClick={() => setShowCustom(true)}
          className={`flex-1 py-3 rounded-xl border-2 text-sm font-bold transition-all active:scale-95 ${
            showCustom
              ? "text-white border-transparent"
              : "border-[hsl(0,0%,88%)] text-[hsl(0,0%,30%)]"
          }`}
          style={showCustom ? { backgroundColor: primaryColor } : {}}
        >
          Outro valor
        </button>
      </div>

      {showCustom && (
        <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} className="mt-3 flex gap-2">
          <input
            type="number"
            min="1"
            step="1"
            value={customTip}
            onChange={(e) => setCustomTip(e.target.value)}
            placeholder="R$ 0"
            className="flex-1 h-11 rounded-xl border border-[hsl(0,0%,88%)] px-3 text-sm text-[hsl(0,0%,13%)] outline-none focus:ring-2"
            style={{ "--tw-ring-color": `${primaryColor}40` } as any}
          />
          <button
            onClick={handleCustom}
            disabled={!customTip || Number(customTip) <= 0}
            className="h-11 px-5 rounded-xl text-white font-bold text-sm disabled:opacity-40 transition-all active:scale-95"
            style={{ backgroundColor: primaryColor }}
          >
            OK
          </button>
        </motion.div>
      )}
    </div>
  );
};
